// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function ThankYouFormBhima(props) {
  var redirectionUrl = props.redirectionUrl;
  var textHtml = Substitution$ReactHooksTemplate.renderQuestionText(ThankYou$ReactHooksTemplate.getTextTranslation(props.thankYou, SurveyLanguage$ReactHooksTemplate.name(props.language)), props.substitutionVariables);
  React.useEffect((function (param) {
          var timerId = setTimeout((function (param) {
                  if (redirectionUrl !== undefined) {
                    window.location.href = RedirectionUrl$ReactHooksTemplate.url(redirectionUrl);
                    return ;
                  }
                  
                }), 500);
          return (function (param) {
                    clearTimeout(timerId);
                  });
        }), []);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  className: "survey-rich-text text-xl leading-normal font-medium text-" + props.textColor,
                                  dangerouslySetInnerHTML: {
                                    __html: textHtml
                                  }
                                }),
                            className: "text-center py-10"
                          }),
                      JsxRuntime.jsx("img", {
                            src: Image$ReactHooksTemplate.bhimaThankyou
                          })
                    ],
                    className: "flex flex-col h-full"
                  }),
              className: "max-w-840-px mx-auto px-60-px small-px-20-px min-h-screen flex flex-col\n    justify-center pt-120-px bg-white"
            });
}

var make = ThankYouFormBhima;

exports.make = make;
/* react Not a pure module */
